import { createSlice, PayloadAction, Dispatch } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { clearError } from './errorSlice';
import axios from 'axios';
import { handleApiError } from '@/utils/apiErrorHandler';
import { AxiosError } from 'axios';

interface LinkObject {
    faq: string;
    optumId: string;
}

interface profileSliceState {
    links: LinkObject;
    loading: boolean;
    error: string | null;
}

const initialState: profileSliceState = {
    links: { faq: '', optumId: '' },
    loading: false,
    error: null,
};

export const physicianGroupConfirmationLinks = createAsyncThunk(
    'profile/physicianGroupConfirmationLinks',
    async (key: string, { dispatch }: { dispatch: Dispatch }) => {
        let url = `/papi/content/data?key=${key}`;
        try {
            dispatch(clearError());
            // Fetch fetchMeasuresComplianceRules - use base endpoint (no mpin in path)
            // The API will use the authenticated user's mpin
            console.log('routeUrl Fetching conditions from:', url);
            const response = await axios.get(url);
            return response.data;
        } catch (error) {
            //  pendingRequests.delete(requestId);
            handleApiError(error as AxiosError, "profile", dispatch);
            throw error;
        }
    }
);

const profileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers: {
        fetchLinksStart(state) {
            state.loading = true;
            state.error = null;
        },
        fetchLinksSuccess(state, action: PayloadAction<LinkObject>) {
            state.links = action.payload;
            state.loading = false;
            state.error = null;
        },
        fetchLinksFailure(state, action: PayloadAction<string>) {
            state.loading = false;
            state.error = action.payload;
        },
        clearLinks(state) {
            state.links = { faq: '', optumId: '' };
            state.error = null;
            state.loading = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(physicianGroupConfirmationLinks.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(physicianGroupConfirmationLinks.fulfilled, (state, action: PayloadAction<LinkObject>) => {
                state.links = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(physicianGroupConfirmationLinks.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'Failed to fetch links';
            });
    }
});

export const {
    fetchLinksStart,
    fetchLinksSuccess,
    fetchLinksFailure,
    clearLinks,
} = profileSlice.actions;

export default profileSlice.reducer;